import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/@Services';
import { FormsModule } from '@angular/forms';
import { InputComponent } from '../@common/input/input.component';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [
        FormsModule,
        InputComponent,
        LoadingSpinnerComponent,
    ],
})
export class LoginComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {}

  public loginGroup: { username: string; password: string } = {
    username: null,
    password: null,
  };
  public isLoading: boolean;
  protected counter: number = 0;

  public signIn(): void {
    this.isLoading = true;
    this.authService
      .signIn(this.loginGroup)
      .then(() => {
        this.isLoading = false;
        this.authService.IsAuthenticated = true;
        this.router.navigate(['admin']);
      })
      .catch(() => {
        this.isLoading = false;
        console.log('login failed');
      });
  }
}
